import { useState } from "react";
import { notification } from "antd";
import { journalsQueries } from "@/entities/journal";
import { queryClient } from "@/shared/lib/react-query";
import { NOTIFICATION_MESSAGES } from "@/shared/utils";
import { useBuildSignLinePartOne } from "../mutate-hooks/use-build-sign-line-part-one";
import { useBuildSignLinePartTwo } from "../mutate-hooks/use-build-sign-line-part-two";

export const useSetupSigningString = (
  mainJournalData: any,
  search?: string,
) => {
  const [signingString, setSigningString] = useState("");

  const { mutateAsync: getXmlPartOne, isPending: isPartOnePending } =
    useBuildSignLinePartOne();
  const { mutateAsync: getXmlPartTwo, isPending: isPartTwoPending } =
    useBuildSignLinePartTwo();

  const setupSigningStringPartOne = async (
    params: {
      sectionFourListId: string;
      itemNoVersionId: string;
      itemPartOneId: string;
      signerEmployeeId: string;
    },
    onOpen: () => void,
  ) => {
    try {
      const res = await getXmlPartOne(params);
      setSigningString(res);
      onOpen();
      queryClient.invalidateQueries({
        queryKey: journalsQueries.getSection4({
          section4ListId: mainJournalData?.mainJournal?.section4?.sectionListId || "",
          search,
        }).queryKey,
      });
    } catch (err: any) {
      notification.error({
        message: NOTIFICATION_MESSAGES.XML_SIGN_P1_GENERATION_ERROR, // "Ошибка генерации XML подписи (часть 1)"
        description: err?.message || "Неизвестная ошибка",
        placement: "topRight",
      });
    }
  };

  const setupSigningStringPartTwo = async (
    params: {
      sectionFourListId: string;
      itemNoVersionId: string;
      itemPartTwoId: string;
      signerEmployeeId: string;
    },
    onOpen: () => void,
  ) => {
    try {
      const res = await getXmlPartTwo(params);
      setSigningString(res);
      onOpen();
      queryClient.invalidateQueries({
        queryKey: journalsQueries.getSection4({
          section4ListId: mainJournalData?.mainJournal?.section4?.sectionListId || "",
          search,
        }).queryKey,
      });
    } catch (err: any) {
      notification.error({
        message: NOTIFICATION_MESSAGES.XML_SIGN_P2_GENERATION_ERROR, // "Ошибка генерации XML подписи (часть 2)"
        description: err?.message || "Неизвестная ошибка",
        placement: "topRight",
      });
    }
  };

  return {
    signingString,
    setupSigningStringPartOne,
    setupSigningStringPartTwo,
    isPending: isPartOnePending || isPartTwoPending,
  };
};
